export const SessionStorageKeys = {
  MetadataParams: 'metadataParams',
} as const;
